import React, { SyntheticEvent, FunctionComponent } from 'react';
import classnames from 'classnames';
import Close from 'dibs-icons/exports/Close';
import { Spinner } from '../../../../Spinner';
import { RotatingArrow } from '../../../../RotatingArrow';
import { SIZES, DIRECTIONS } from '../../../constants';

import styles from './Decorators.scss';

type DecoratorsProps = {
    arrowDirection: typeof DIRECTIONS.up | typeof DIRECTIONS.down;
    arrowPaddingRight: typeof SIZES.small | typeof SIZES.medium;
    children?: React.ReactNode;
    clearable: boolean;
    dataTn: string;
    disabled: boolean;
    isLoading: boolean;
    onClick?: (e: SyntheticEvent<HTMLDivElement>) => void;
    onMouseDown?: () => void;
    onClear: () => void;
    useNativeClickthrough?: boolean;
};

export const Decorators: FunctionComponent<DecoratorsProps> = props => {
    const {
        arrowDirection,
        arrowPaddingRight,
        children,
        clearable,
        dataTn,
        disabled,
        onClick,
        onMouseDown,
        isLoading,
        onClear,
        useNativeClickthrough,
    } = props;
    const decoratorWrapperClassName = classnames(styles.decoratorWrapper, {
        [styles.nativeClickthrough]: useNativeClickthrough,
    });
    const spinnerClassName = classnames(styles.loadSpinner, {
        [styles.marginRight]: !clearable || !!children,
    });
    const childClassName = classnames({ [styles.marginRight]: !!children && !clearable });
    const clearableClassName = classnames(styles.clearable, {
        [styles.clearableEnabled]: !disabled,
    });

    return (
        <div className={decoratorWrapperClassName} onClick={onClick} onMouseDown={onMouseDown}>
            {isLoading && (
                <div className={spinnerClassName} data-tn={`${dataTn}-loader`}>
                    <Spinner size={SIZES.tiny} />
                </div>
            )}
            {children && <div className={childClassName}>{children}</div>}
            {clearable && (
                <div
                    className={clearableClassName}
                    onClick={disabled ? undefined : onClear}
                    data-tn={`${dataTn}-clear`}
                >
                    <Close />
                </div>
            )}
            <RotatingArrow direction={arrowDirection} paddingRight={arrowPaddingRight} />
        </div>
    );
};
